<template>
  <h1>URL Studio. Mass URL Editor/Examiner/Extractor
      <button class="btn btn-warning help_blink" @click="showHelp=!showHelp"><span v-if="!showHelp">Show Help</span><span v-else>Hide Help</span></button>
  </h1>
    <div v-show="showHelp" id="help" class="p-4 ms-3 me-3 ">
        <div class="p-2">
            <h2>Help</h2>
            <h5><b>A useful tool for decoding then examining/editing parameters in URLs and perhaps exporting that out to a list or CSV data.</b></h5>
            <h5>All processing is done on your client, nothing is sent to a server!</h5>
            <p>Paste URL(s) into top text area and they will be decoded and displayed. By default all parameters are extracted, otherwise you can flip the
                button in the parameters area and only add parameters you are interested in. </p>
            <p>Turn on Show Origin Data to see host, path, port etc. (Note due to limitations in the underlying implementation of a URL object, only a few
                protocols are supported, and if the port is the default port for the protocol [i.e. http: port 80] it gets removed).</p>
            <p>If a URL is found in a parameter, you can jump straight to the link, or even add it into the list of URLs for analysis.</p>
            <p>If a parameter contains a valid JSON string, there is an option to pretty-print the data.</p>
            <p>Parameters can be copied to all URLs or removed from all URLs. Clicking the bookmark button will add that parameter to the list of list of URLs
                to extract once you disable Get All Parameters</p>
            <p>By the output box there are links back to the this page with all the current options selected, or the same but with all the URLs
                in the list already added</p>
            <p><a href="/urlstudio/?options=%7B%22getAllParameters%22%3Atrue%2C%22autoUpdateParams%22%3Atrue%2C%22autoAddUrls%22%3Atrue%2C%22outputType%22%3A%220%22%2C%22showHeader%22%3Atrue%2C%22showUrl%22%3Atrue%2C%22showNotSet%22%3Atrue%2C%22showExtra%22%3Afalse%2C%22wantedParameters%22%3A%5B%5D%2C%22urls%22%3A%22http%3A%2F%2Fjames%3Abond%40completely.unrelated-domainname.com%3A78%2Fexample%2520pathname%2Fbit%2Flonger%3Ffe%3D%25CE%25A4%25CE%25BF%2B%25CE%25B6%25CE%25B7%25CF%2584%25CE%25BF%25CF%258D%25CE%25BC%25CE%25B5%25CE%25BD%25CE%25BF%2B%25CE%25B5%25CF%2580%25CE%25AF%25CE%25B4%25CE%25B5%25CE%25B9%25CE%25BE%25CE%25B7%25CF%2582%26fi%3D6867c29ed6bd7b63887996993598568f%26fo%3Dhttps%253A%252F%252Fen.wikipedia.org%252Fwiki%252FWikipedia%253AToday%252527s_featured_article%26fum%3D%257B%2522_id%2522%253A%2522GMI72P3O1Q4NNS08%2522%252C%2522name%2522%253A%2522Josefina%2BRountree%2522%252C%2522dob%2522%253A%25222021-12-11%2522%252C%2522address%2522%253A%257B%2522street%2522%253A%25222292%2BSaint%2522%252C%2522town%2522%253A%2522Comber%2522%252C%2522postode%2522%253A%2522BN7%2B0KP%2522%257D%252C%2522pets%2522%253A%255B%2522Chester%2522%252C%2522Oliver%2522%255D%252C%2522score%2522%253A2.8%252C%2522verified%2522%253Atrue%252C%2522salary%2522%253A57768%257D%23end%5Cr%5Cnhttp%3A%2F%2Fcompletely.unrelated-domainname.com%2F%3Ffe%3D%25E7%25AC%25AC%25E4%25B8%2583%25E7%25AB%25A0%2B%25E7%25AC%25AC%25E5%2585%25AB%25E7%25AB%25A0%2B%25E7%25AC%25AC%25E5%2585%25AD%25E7%25AB%25A0%2B%25E7%25AC%25AC%25E5%259B%259B%25E7%25AB%25A0.%26fi%3Daa2d143e1605b4f109a8cb54cac31f85%26fo%3Dhttps%253A%252F%252Fwww.google.com%252Fsearch%253Fq%253Dcute%252Bsloths%26fum%3D%257B%2522_id%2522%253A%2522XMV43QKTXYZFKE4C%2522%252C%2522name%2522%253A%2522Long%2BOlds%2522%252C%2522dob%2522%253A%25222014-04-20%2522%252C%2522address%2522%253A%257B%2522street%2522%253A%25226487%2BShawlea%2522%252C%2522town%2522%253A%2522Fordwich%2522%252C%2522postode%2522%253A%2522EX7%2B2MX%2522%257D%252C%2522pets%2522%253A%255B%2522Belle%2522%252C%2522Bentley%2522%255D%252C%2522score%2522%253A5.6%252C%2522verified%2522%253Atrue%252C%2522salary%2522%253A57185%257D%22%7D" target="_blank">
                Click here for an example</a> pre-populated with a couple URLs themselves containing URLs and JSON.</p>
        </div>
    </div>
  <div class="mb-3">
    <h4>URLs:</h4>

    <div class="outUrl p-2 mb-2">
      <div>
                <textarea id="urlsText" style="width:100%" rows="5" v-model="urlsText" placeholder="Add URL(s) here"
                          @paste="pasteUrls"
                          @input="urlsChanged=true;"></textarea>
      </div>
      <div class="d-flex flex-wrap align-items-center ">
        <button v-if="urls.length==0" class="btn btn-primary me-2 mb-2" :disabled="urlsText.trim().length===0"
                @click="addURLs(urlsText,'top',0,true)">Add URLs
        </button>
        <button v-if="urls.length!=0" class="btn btn-primary me-2 mb-2" :disabled="urlsText.trim().length===0"
                @click="addURLs(urlsText,'top',0,true)">Add URLs to Top
        </button>
        <button v-if="urls.length!=0" class="btn btn-primary me-2 mb-2" :disabled="urlsText.trim().length===0"
                @click="addURLs(urlsText,'bottom',0,true)">Add URLs to Bottom
        </button>

        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" id="autoAdd" v-model="autoAddUrls">
          <label class="form-check-label" for="autoAdd">Auto add URLs when pasting to an empty box</label>
        </div>
        <button v-if="urls.length!=0" class="ms-auto align-self-start btn btn-danger me-2 " @click="clearUrls">
          Clear All URLs
        </button>
      </div>
    </div>

    <h4>Parameters to Add/Extract</h4>
    <div class="outUrl">
        <div class="d-flex gap-2 align-items-center p-2 flex-wrap ">
            <div class="form-check form-switch py-2">
                <input class="form-check-input" type="checkbox" id="getAllParams" v-model="getAllParameters"
                       v-on:change="getAllParamsChanged">
                <label class="form-check-label" for="getAllParams">Get All Parameters</label>
            </div>

            <!--        <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" id="autoUpdateParams" v-model="autoUpdateParams"
                             v-on:change="autoUpdateParamsChanged" :disabled="getAllParameters">
                      <label class="form-check-label" for="autoUpdateParams">Auto update parameter names</label>
                    </div>
                    <button class="btn btn-primary m2" :disabled="!canUpdate"
                            @click="updateParams();wantedParametersChanged=false">Update Parameters
                    </button>-->
            <button v-if="!getAllParameters" :disabled="wantedParameters.length==0 || getAllParameters" class="align-self-start btn btn-danger me-2 " @click="clearParameters">
                Clear Parameters
            </button>
        </div>

        <div class="d-flex flex-wrap">
        <div class="input-group mb-2 m-2" style="width: 10rem;min-width:10rem"
             v-for="(wantedParameter, index) in wantedParameters" :key="index">
          <input type="text" class="form-control" placeholder="Parameter Name" aria-label="Parameter Name"
                 v-model="wantedParameters[index]" v-on:input="wantedParametersTextboxChanged"
                 :disabled="getAllParameters">
          <button class="btn btn-outline-secondary bgg p-1" @click="deleteFromList(index)"
                  :disabled="getAllParameters"><i class="bi bi-trash"></i></button>
        </div>

        <div class="input-group mb-2 m-2" style="width: 13rem;min-width:13rem">
          <input type="text" class="form-control" placeholder="Add parameter to view"
                 aria-label="Add parameter to view" v-model="newParameter" :disabled="getAllParameters"
                 @keyup.enter="(newParameter.length>0 && !wantedParameters.includes(newParameter)) ? addNewParameter() : false">
          <button class="btn btn-success p-1"
                  :disabled="getAllParameters || newParameter.length<1 || wantedParameters.includes(newParameter)">
            <i class="bi bi-plus-square" @click="addNewParameter"></i></button>
        </div>
      </div>
    </div>
  </div>

  <h4 class="d-flex"><span class="align-self-start">Output</span>
    <span class="ms-auto align-self-start">
            <a class="btn btn-link" id="optionsLink" href="#" target="_blank" role="button" @mouseenter="buildOptionsLink" @focusin="buildOptionsLink" @click="buildOptionsLink">Link With Current Options</a>
            <a class="btn btn-link" id="optionsLinkURLs" v-if="urls.length>0" href="" target="_blank" role="button" @mouseenter="buildOptionsLink($event,true)" @focusin="buildOptionsLink($event,true)" @click="buildOptionsLink($event,true)">Link With Options and URLs</a>
        </span>
  </h4>

  <div class="p-3 mb-2 outUrl">
    <div class="form-check form-switch form-check-inline">
      <input class="form-check-input" type="checkbox" id="showExtra" v-model="showExtra" @click="showExtraChanged">
      <label class="form-check-label" for="showExtra">Show Origin Data</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" v-model="outputType" id="outEditor" value="0" @click="resizeAllTAs">
      <label class="form-check-label" for="outEditor">Editor</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" v-model="outputType" id="outTable" value="1" @click="buildTableParamList">
      <label class="form-check-label" for="outTable">Table</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" v-model="outputType" id="outList" value="2" @click="buildCSV">
      <label class="form-check-label" for="outList">CSV/List</label>
    </div>
    <div class="form-check form-switch form-check-inline">
      <input class="form-check-input" type="checkbox" id="showHeader" v-model="showHeader" :disabled="outputType!=2" v-on:change="buildCSV">
      <label class="form-check-label" for="showHeader">Show header</label>
    </div>
    <div class="form-check form-switch form-check-inline">
      <input class="form-check-input" type="checkbox" id="showUrl" v-model="showUrl" :disabled="outputType!=2"  v-on:change="buildCSV">
      <label class="form-check-label" for="showUrl">Show URL</label>
    </div>
    <div class="form-check form-switch form-check-inline">
      <input class="form-check-input" type="checkbox" id="showNotSet" v-model="showNotSet" :disabled="outputType!=2" v-on:change="buildCSV">
      <label class="form-check-label" for="showNotSet">Show "<i>&lt;not set&gt;</i>"</label>
    </div>
    <button class="btn btn-primary" :disabled="outputType!=2"
            @click="downloadCSV">Download CSV
    </button>
  </div>

    <div v-if="outputType==0">
        <div class="input-group p-3 outUrl mb-3" v-for="(urlOut, index) in urls" :key="urlOut.key">
            <div v-if="urlOut.errorText==null" style="width:100%">
                <div class="input-group mb-2">
                    <span class="input-group-text">#{{ index + 1 }}</span>
                    <div class="input-group-text TAAutosizeParent">
                    <textarea type="text" rows=1 class="form-control TAautosize noBorder" readonly placeholder="URL"
                              aria-label="Parameter value" :value="urlOut.hrefText" :id="'url'+urlOut.key"></textarea>
                    </div>
                    <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Open URL"
                            @click="itemLink('url'+urlOut.key)"><i class="bi-box-arrow-up-right"></i></button>
                    <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy URL"
                            @click="itemCopy('url'+urlOut.key);urlOut.urlCopied=true;"><i class="bi"
                                                                                          :class="urlOut.urlCopied ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                    </button>
                    <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Delete URL"
                            @click="deleteUrl(index);"><i class="bi-trash"></i></button>
                </div>
                <div v-if="showExtra" class="d-grid gap-2 ms-4 mb-2 p-3 showExtra">
                    <div class="d-flex flex-wrap gap-2">

                        <div class="input-group flex-shrink-1 flex-grow-2 origin-piece" style="width:15rem">
                            <span class="input-group-text"><span class="mw">Protocol</span></span>
                            <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                                   aria-label="URL Protocol" :id="'protocol-'+urlOut.key"
                                   v-model="urlOut.origin.protocol" @input="roundTripOrigin(urlOut,'protocol')"
                                   data-lpignore="true"
                                   v-if="urlOut.originDisabled">
                            <select v-else class="form-select form-control" aria-label="URL Protocol"
                                    v-model="urlOut.origin.protocol" :id="'protocol-'+urlOut.key"
                                    @change="roundTripOrigin(urlOut,'protocol')">
                                <option>http:</option>
                                <option>https:</option>
                                <option>file:</option>
                                <option>ftp:</option>
                                <option>ws:</option>
                                <option>wss:</option>
                            </select>
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('protocol-'+urlOut.key);urlOut.originCopied['protocol']=true;">
                                <i :class="urlOut.originCopied['protocol'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'protocol')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                        <div class="input-group flex-shrink-1 flex-grow-1 origin-piece" style="width:23rem">
                            <span class="input-group-text"><span class="mw">Hostname</span></span>
                            <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                                   aria-label="URL hostname" :id="'hostname-'+urlOut.key"
                                   v-model="urlOut.origin.hostname" @input="roundTripOrigin(urlOut,'hostname')"
                                   data-lpignore="true"
                            >
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('hostname-'+urlOut.key);urlOut.originCopied['hostname']=true;">
                                <i :class="urlOut.originCopied['hostname'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'hostname')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                        <div class="input-group flex-shrink-1 flex-grow-2 origin-piece" style="width:15rem">
                            <span class="input-group-text"><span class="mw">Port</span></span>
                            <input type="number" min="0" max="65535" class="form-control"
                                   :disabled="urlOut.originDisabled" aria-label="URL Port" :id="'port-'+urlOut.key"
                                   v-model="urlOut.origin.port" @input="roundTripOrigin(urlOut,'port')"
                            >
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('port-'+urlOut.key);urlOut.originCopied['port']=true;">
                                <i :class="urlOut.originCopied['port'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'port')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                    </div>
                    <div class="d-flex flex-wrap gap-2">

                        <div class="input-group flex-shrink-1 flex-grow-1 origin-piece">
                            <span class="input-group-text"><span class="mw">Hash</span></span>
                            <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                                   aria-label="URL Hash" :id="'hash-'+urlOut.key"
                                   v-model="urlOut.origin.hash" @input="roundTripOrigin(urlOut,'hash')"
                                   data-lpignore="true">
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('hash-'+urlOut.key);urlOut.originCopied['hash']=true;">
                                <i :class="urlOut.originCopied['hash'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'hash')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                        <div class="input-group flex-shrink-1 flex-grow-1 origin-piece">
                            <span class="input-group-text"><span class="mw">Username</span></span>
                            <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                                   aria-label="URL Username" :id="'username-'+urlOut.key"
                                   v-model="urlOut.origin.username" @input="roundTripOrigin(urlOut,'username')"
                                   data-lpignore="true">
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('username-'+urlOut.key);urlOut.originCopied['username']=true;">
                                <i :class="urlOut.originCopied['username'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'username')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                        <div class="input-group flex-shrink-1 flex-grow-1 origin-piece">
                            <span class="input-group-text"><span class="mw">Password</span></span>
                            <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                                   aria-label="URL password" :id="'password-'+urlOut.key"
                                   v-model="urlOut.origin.password" @input="roundTripOrigin(urlOut,'password')"
                                   data-lpignore="true">
                            <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                    @click="itemCopy('password-'+urlOut.key);urlOut.originCopied['password']=true;">
                                <i :class="urlOut.originCopied['password'] ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                            </button>
                            <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                    title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                    @click="setAllOriginParamsNamed(urlOut, 'password')"><i
                                class="bi bi-journal-plus"></i>
                            </button>
                        </div>

                    </div>
                    <div class="input-group ">
                        <span class="input-group-text"><span class="mw">Pathname</span></span>
                        <input type="text" class="form-control" :disabled="urlOut.originDisabled"
                               aria-label="URL Pathname" :id="'pathname-'+urlOut.key"
                               v-model="urlOut.origin.pathname" @input="roundTripOrigin(urlOut,'pathname')"
                               data-lpignore="true">
                        <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy"
                                @click="itemCopy('pathname-'+urlOut.key);urlOut.urlCopied=true;">
                            <i class="bi bi-clipboard"></i></button>
                        <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                title="Copy parameter to all URLs" :disabled="urlOut.originDisabled"
                                @click="setAllOriginParamsNamed(urlOut, 'pathname')"><i
                            class="bi bi-journal-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="d-grid gap-2 mb-2 ms-4">
                    <div class="d-grid gap-2">
                        <div v-for="(parameter, parameterName, wpcIndex) in urlOut.wantedParameters"
                             :key="parameter.key">
                            <div class="input-group" v-if="urlOut.wantedParameters[parameterName].value!=null">
                                <span class="input-group-text"><span class="mw">{{ parameterName }}</span></span>
                                <input v-if="!parameter.showJSONValue" type="text" class="form-control"
                                       aria-label="Parameter value"
                                       v-model="parameter.value" :id="'url'+index+'-'+wpcIndex"
                                       @input="changeParam(urlOut,parameterName)">
                                <div v-if="parameter.showJSONValue" class="input-group-text TAAutosizeParent">
                                    <textarea readonly class="form-control TAautosize border-0 prettyJSON"
                                              :id="'TA'+parameter.key" v-model="parameter.prettyJSONValue"></textarea>
                                </div>
                                <button v-if="parameter.JSONvalue!=null"
                                        class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Show Pretty JSON" @click="togglePrettyJSON(parameter)">
                                    <i :class="parameter.showJSONValue ? 'bi-arrows-angle-contract' : 'bi-arrows-angle-expand'"></i>
                                </button>
                                <button v-if="parameter.isURL" class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Open URL" @click="itemLink('url'+index+'-'+wpcIndex)"><i
                                    class="bi-box-arrow-up-right"></i></button>
                                <button v-if="parameter.isURL"
                                        class="btn noShadow btn-lg p-1 btn-outline-secondary bgg icon-flipped"
                                        title="Add URL underneath this one" @click="addUnderneath(index,parameterName)">
                                    <i
                                        class="bi-chevron-bar-down"></i></button>
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Copy parameter to clipboard"
                                        @click="itemCopy('url'+index+'-'+wpcIndex);parameter.copied=true;">
                                    <i class="bi" :class="parameter.copied ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                                </button>
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Copy parameter to all URLs"
                                        @click="setAllParamsNamed(parameterName,parameter.value)"><i
                                    class="bi bi-journal-plus"></i></button>
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Remove parameter from this URL"
                                        @click="removeParam(urlOut,parameterName)"><i
                                    class="bi bi-file-earmark-minus"></i></button>
                                <button v-if="getAllParameters"
                                        class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        :title="wantedParameters.includes(parameterName) ? 'Remove parameter from your list' : 'Add parameter to your list'"
                                        @click="toggleParameter(parameterName)">
                                    <i class="bi"
                                       :class="wantedParameters.includes(parameterName) ? 'bi-bookmark-fill' : 'bi-bookmark'"></i>
                                </button>
                            </div>

                            <div class="input-group" v-else>
                                <span class="input-group-text"><span class="mw">{{ parameterName }}</span></span>
                                <input type="text" class="form-control" disabled placeholder="Not set"
                                       aria-label="Parameter value" :id="'url'+index+'-'+wpcIndex"
                                       @input="changeParam(urlOut,parameterName)">
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Copy Parameter to clipboard"
                                        @click="itemCopy('url'+index+'-'+wpcIndex);parameter.copied=true;">
                                    <i class="bi" :class="parameter.copied ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                                </button>
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Add Parameter"
                                        @click="parameter.value='';changeParam(urlOut,parameterName)">
                                    <i class="bi bi-file-earmark-plus"></i>
                                </button>
                                <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        title="Remove parameter from all URLs"
                                        @click="removeAllParamsNamed(parameterName)">
                                    <i class="bi bi-journal-minus"></i></button>
                                <button v-if="getAllParameters"
                                        class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                        :title="wantedParameters.includes(parameterName) ? 'Remove parameter from your list' : 'Add parameter to your list'"
                                        @click="toggleParameter(parameterName)">
                                    <i class="bi"
                                       :class="wantedParameters.includes(parameterName) ? 'bi-bookmark-fill' : 'bi-bookmark'"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="getAllParameters" class="d-grid gap-2 mb-2 ms-4">
                    <div class="input-group">
                        <span class="input-group-text mw"><em>New Parameter Name</em></span>
                        <input type="text" class="form-control" aria-label="New parameter name"
                               style="min-width:1rem; flex-grow: 2"
                               v-model="urlOut.newParameter"/>
                        <span class="input-group-text"><em>Value</em></span>
                        <input type="text" class="form-control " aria-label="New parameter value" style="flex-grow:5"
                               v-model="urlOut.newParameterValue"
                               :disabled="urlOut.newParameter.length==0 || urlOut.wantedParameters[urlOut.newParameter]!==undefined"
                               @keyup.enter="addNewParameterOnUrl(urlOut)"/>
                        <button class="btn noShadow btn-lg p-1 btn-outline-secondary bgg"
                                title="Add new parameter" @click="addNewParameterOnUrl(urlOut)"
                                :disabled="urlOut.newParameter.length==0 || urlOut.wantedParameters[urlOut.newParameter]!==undefined">
                            <i class="bi-file-earmark-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div v-else style="width:100%">
                <div class="input-group mb-2 fw-bolder">Invalid URL</div>
                <div class="input-group mb-2">
                    <span class="input-group-text">#{{ index + 1 }}</span>
                    <div class="input-group-text TAAutosizeParent">
                    <textarea type="text" rows=1 class="form-control TAautosize noBorder" placeholder="URL"
                              aria-label="Parameter value" v-model="urlOut.hrefText" :id="'url'+urlOut.key"
                              @input="resizeTA('url'+urlOut.key)" @keyup.enter="changeInvalidURL(urlOut)"></textarea>
                    </div>
                    <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary" title="Check URL"
                            @click="changeInvalidURL(urlOut)">
                        <i class="bi bi-arrow-repeat"></i>
                    </button>
                    <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Copy URL"
                            @click="itemCopy('url'+urlOut.key);urlOut.urlCopied=true;"><i class="bi"
                                                                                          :class="urlOut.urlCopied ?  'bi-clipboard-check' :'bi-clipboard'"></i>
                    </button>
                    <button class="bgg btn noShadow btn-lg p-1 btn-outline-secondary bgg" title="Delete URL"
                            @click="deleteUrl(index);"><i class="bi-trash"></i></button>
                </div>
            </div>
        </div>
    </div>
    <div v-if="outputType==1 && urls.length>0" class="p-2 outUrl table-wrapper">
        <div class="pb-2">
            <button class="btn btn-primary" @click="copyTable">Copy Table</button>
        </div>
        <table class="table table-striped table-bordered border-secondary" id="urlTable">
            <thead>
            <tr>
                <th>URL</th>
                <template v-if="showExtra">
                    <th v-for="item in $options.local.originlList" :key="item">{{ item }}</th>
                </template>
                <th v-for="param in tableParamList" :key="param">{{ param }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(urlOut) in urls" :key="urlOut.id">
                <td class="urlTableEllipsis">{{ urlOut.hrefText }}</td>
                <template v-if="showExtra">
                    <td v-for="item in $options.local.originlList" :key="item">
                    <template v-if="urlOut.origin[item]!==undefined">
                        {{ urlOut.origin[item] }}
                    </template>
                    <span v-else class="text-secondary fst-italic">&lt;not set&gt;</span>
                    </td>
                </template>
                <td v-for="param in tableParamList" :key="param">
                    <template v-if="urlOut.wantedParameters[param]!==undefined">
                        {{ urlOut.wantedParameters[param].value }}
                    </template>
                    <span v-else class="text-secondary fst-italic">&lt;not set&gt;</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>

  <div v-if="outputType==2 && urls.length>0" class="p-2 outUrl">
      <div class="pb-2">
          <button class="btn btn-primary" @click="copyCSV">Copy CSV/List</button>
      </div>

      <textarea readonly class="form-control outputAutosize" id="csvOutText" v-model="csvText" style="width: 100%" ></textarea>
  </div>

</template>

<script>
const isUrl = string => {
  try { return Boolean(new URL(string)); }
  catch(e){ return false; }
}

class UrlOut {
  urlObject=null;
  urlCopied=false;
  hrefText=null;
  errorText=null;
  wantedParameters= { } ;
  newParameter="";
  newParameterValue="";
  origin={};
  originDisabled=false;
  originCopied={};
  key=String(Math.random()).substring(2);
}

class Parameter {
  constructor(value) {
    this.value = value;
  }
  value="";
  copied=false;
  isURL=false;
  JSONvalue=null;
  prettyJSONValue=null;
  showJSONValue=false;
  key=String(Math.random()).substring(2);
}

const optionsItems=[
  "getAllParameters",
  "autoUpdateParams",
  "autoAddUrls",
  "outputType",
  "showHeader",
  "showUrl",
  "showNotSet",
  "showExtra"
];

const supportedProtocols=[
  "http:","https:","ftp:","file:","ws:","wss:"
];

const protocolRegex=/^[a-z0-9][a-z0-9-]+:/;

export default {
    name: "URLStudio",
    data() {
        return {
            urlsText:"",
            wantedParameters: [],
            getAllParameters: true,
            autoUpdateParams: true,
            autoAddUrls: true,
            outputType: 0,
            showHeader: true,
            showUrl: true,
            showNotSet: true,
            showExtra: false,

            urls: [],
            urlsChanged: true,
            wantedParametersChanged: false,
            newParameter: '',
            getAllParametersChanged: false,
            tableParamList: [],
            csvText: [],
            siteURL: null,
            showHelp:false
        }
    },
    local: {
        originlList: ["protocol", "hostname", "port", "pathname", "hash", "username", "password"]
    },
    computed: {
        canUpdate() {
            return this.urls.length > 0 && (this.wantedParametersChanged || this.getAllParametersChanged);
        }
    },
    methods: {
        wantedParametersTextboxChanged() {
            if ( this.autoUpdateParams )
                this.updateParams();
            else
                this.wantedParametersChanged = true;
        },
        deleteFromList(index) {
            this.wantedParameters.splice(index, 1);
            this.updateParams();
        },
        addParameter(param) {
            this.wantedParameters.push(param);
            this.wantedParameters = this.wantedParameters.sort();
            this.updateParams();
        },
        addNewParameter() {
            this.addParameter(this.newParameter);
            this.newParameter = '';
        },
        clearParameters() {
            this.wantedParameters = [];
            this.updateParams();
        },
        toggleParameter(param) {
            let index = false;
            if ( (index = this.wantedParameters.indexOf(param)) !== -1 ) {
                this.wantedParameters.splice(index, 1);
            } else {
                this.addParameter(param);
            }
            this.$forceUpdate();
        },
        itemCopy(id) {
            let text = document.getElementById(id).value;
            navigator.clipboard.writeText(text);
        },
        itemLink(id) {
            let text = document.getElementById(id).value;
            window.open(text, "_blank");
        },
        updateUrlOut(urlOut) {
            urlOut.hrefText = urlOut.urlObject.href;
            this.resizeTA("url" + urlOut.key);
        },
        changeParam(urlOut, paramName) {
            urlOut.urlObject.searchParams.set(paramName, urlOut.wantedParameters[paramName].value);
            this.updateUrlOut(urlOut, "params");
            this.checkParamFlags(urlOut, paramName);
        },
        checkParamFlags(urlOut, paramName) {
            let val = urlOut.wantedParameters[paramName].value;
            urlOut.wantedParameters[paramName].JSONvalue = null;
            if ( val == null ) {
                urlOut.wantedParameters[paramName].isURL = false;
                return;
            }
            urlOut.wantedParameters[paramName].isURL = isUrl(val);

            if ( (val[0] === '[' && val.endsWith(']')) ||
                (val[0] === '{' && val.endsWith('}')) ) {
                try {
                    urlOut.wantedParameters[paramName].JSONvalue = JSON.parse(val);
                } catch ( e ) {
                    // eslint-disable-next-line
                    ;
                }
            }
        },
        removeParam(urlOut, paramName) {
            urlOut.urlObject.searchParams.delete(paramName);
            urlOut.wantedParameters[paramName].value = null;
            this.updateUrlOut(urlOut, "params");
        },
        removeAllParamsNamed(paramName) {
            for ( let item of this.urls ) {
                if ( item.urlObject != null ) {
                    item.urlObject.searchParams.delete(paramName);
                    item.wantedParameters[paramName].value = null;
                }
                this.updateUrlOut(item, "params");
            }
        },
        setAllParamsNamed(paramName, value) {
            for ( let item of this.urls ) {
                if ( item.urlObject != null ) {
                    item.urlObject.searchParams.set(paramName, value);
                    if ( item.wantedParameters[paramName] === undefined )
                        item.wantedParameters[paramName] = new Parameter(value)
                    else
                        item.wantedParameters[paramName].value = value;
                    this.checkParamFlags(item, paramName);
                }
                this.updateUrlOut(item, "params");
            }
        },
        resizeTA(id) {
            let el = document.getElementById(id)
            if ( el == null )
                return;
            this.$nextTick(function () {
                el.style.height = 'auto';
                let scrollHeight = el.scrollHeight;
                el.style.height = scrollHeight + 'px';
                if ( el.offsetHeight - el.clientHeight > 5 )
                    scrollHeight += el.offsetHeight - el.clientHeight;
                el.style.height = scrollHeight + 'px';
            });
        },
        addURLs(text, where, position, clearText = false) {
            let splitText = text.trim().split("\n")
            let addedKeys = [];
            switch ( where ) {
                case 'top':
                    position = 0;
                    break;
                case 'bottom':
                    position = this.urls.length;
                    break;
                case 'under':
                    position++;
            }
            for ( let url of splitText ) {
                url = url.trim();
                if ( url.length === 0 )
                    continue;
                let newUrlOut = this.createUrlOut(url);
                console.log(newUrlOut);
                addedKeys.push(newUrlOut.key);
                this.urls.splice(position++, 0, newUrlOut);
            }
            this.$nextTick(() => {
                for ( let key of addedKeys )
                    this.resizeTA("url" + key);
            });
            if ( clearText )
                this.urlsText = '';
            if ( this.outputType != 0 ) {
                this.buildTableParamList();
            }
            if ( this.outputType==2 )
                this.buildCSV();
        },
        createUrlOut(urlText) {
            let newUrlOut = new UrlOut();
            try {
                let url = new URL(urlText.trim());
                newUrlOut.hrefText = url.href;
                newUrlOut.urlObject = url;
                this.replaceWantedParameters(newUrlOut);
                this.getOrigin(newUrlOut);
            } catch ( e ) {
                newUrlOut.errorText = e.toString();
                newUrlOut.hrefText = urlText;
            }
            return newUrlOut;
        },
        replaceWantedParameters(urlOut) {
            urlOut.wantedParameters = {};
            let url = urlOut.urlObject;
            if ( this.getAllParameters ) {
                let sortedParamKeys = [...url.searchParams.keys()];
                sortedParamKeys = sortedParamKeys.sort();
                for ( const param of sortedParamKeys ) {
                    urlOut.wantedParameters[param] = new Parameter(url.searchParams.get(param));
                    this.checkParamFlags(urlOut, param);
                }
            } else {
                for ( const param of this.wantedParameters ) {
                    if ( param == "" )
                        continue;
                    urlOut.wantedParameters[param] = new Parameter(url.searchParams.get(param));
                    this.checkParamFlags(urlOut, param);
                }
            }
        },
        getAllParamsChanged() {
            this.updateParams();
            if ( this.getAllParameters )
                this.wantedParametersChanged = false;
        },
        updateParams() {
            this.urls.forEach((urlOut) => {
                this.replaceWantedParameters(urlOut);
            });
            if ( this.outputType > 0 )
                this.buildTableParamList();
            if ( this.outputType == 2 )
                this.buildCSV()
            this.wantedParametersChanged = false;
        },
        autoUpdateParamsChanged() {
            if ( this.autoUpdateParams )
                this.updateParams();
        },
        pasteUrls(event) {
            if ( this.autoAddUrls && this.urlsText == '' ) {
                let paste = (event.clipboardData || window.clipboardData).getData('text');
                this.addURLs(paste, "bottom", 0, true);
                event.preventDefault();
                return false;
            } else
                return true;
        },
        clearUrls() {
            this.urls = [];
        },
        addUnderneath(urlOutIndex, paramName) {
            let urlOut = this.urls[urlOutIndex];
            let urlText = urlOut.wantedParameters[paramName].value;
            this.addURLs(urlText, "under", urlOutIndex);
        },
        deleteUrl(index) {
            this.urls.splice(index, 1);
        },
        resizeAllTAs() {
            window.setTimeout(() => {
                this.urls.forEach((urlOut) => {
                    this.resizeTA("url" + urlOut.key)
                })
                this.resizeTA("csvOutText");
            }, 1);
        },
        buildTableParamList() {
            let paramList = {};
            this.urls.forEach((urlOut) => {
                for ( let key in urlOut.wantedParameters ) {
                    paramList[key] = true;
                }
            });
            paramList = Object.keys(paramList);
            paramList.sort();
            this.tableParamList = paramList;
        },
        buildCSV() {
            this.buildTableParamList();
            let csvData = [];
            if ( this.showHeader ) {
                let row = [];
                if ( this.showUrl )
                    row.push("URL");
                if ( this.showExtra ) {
                    for ( let key of this.$options.local.originlList )
                        row.push(key);
                }
                for ( let key of this.tableParamList )
                    row.push(key);
                csvData.push(row);
            }
            this.urls.forEach((urlOut) => {
                let row = [];
                if ( this.showUrl )
                    row.push(urlOut.hrefText);
                if ( this.showExtra ) {
                    for ( let key of this.$options.local.originlList )
                        row.push(urlOut.origin[key]);
                }
                for ( let key of this.tableParamList ) {
                    if ( urlOut.wantedParameters[key] === undefined ) {
                        if ( this.showNotSet )
                            row.push("<not set>");
                        else
                            row.push("");
                    } else
                        row.push(urlOut.wantedParameters[key].value)
                }
                csvData.push(row);
            });
            // eslint-disable-next-line
            this.csvText = Papa.unparse(csvData);
            window.setTimeout(() => {
                this.resizeTA("csvOutText");
            }, 1)
        },
        resizeWindow() {
            this.resizeAllTAs();
        },
        downloadCSV() {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(new Blob([this.csvText], { type: "text/csv" }));
            a.setAttribute("download", "urldata.csv");
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        addNewParameterOnUrl(urlOut) {
            urlOut.wantedParameters[urlOut.newParameter] = new Parameter(urlOut.newParameterValue);

            urlOut.wantedParameters = Object.keys(urlOut.wantedParameters).sort().reduce(
                (obj, key) => {
                    obj[key] = urlOut.wantedParameters[key];
                    return obj;
                },
                {}
            );

            this.changeParam(urlOut, urlOut.newParameter);
            urlOut.newParameter = "";
            urlOut.newParameterValue = "";
        },
        buildOptionsLink(event, withUrls) {
            this.siteURL.search = '';

            let options = {};
            for ( const i in optionsItems ) {
                options[optionsItems[i]] = this[optionsItems[i]];
            }
            options['wantedParameters'] = Object.assign([], this.wantedParameters);
            if ( withUrls === true ) {
                let URLsText = [];
                for ( const urlObject of this.urls ) {
                    URLsText.push(urlObject.hrefText);
                }
                options['urls'] = URLsText.join('\r\n');
            }
            let optionsText = JSON.stringify(options);

            this.siteURL.searchParams.set("options", optionsText);
            event.target.href = this.siteURL.href;
        },
        togglePrettyJSON(param) {
            param.showJSONValue = !param.showJSONValue;
            if ( param.showJSONValue ) {
                param.prettyJSONValue = JSON.stringify(param.JSONvalue, null, "\t");
                window.setTimeout(() => {
                    this.resizeTA('TA' + param.key)
                }, 10);
            }
        },
        changeInvalidURL(urlOut) {
            try {
                let url = new URL(urlOut.hrefText.trim());
                urlOut.hrefText = url.href;
                urlOut.urlObject = url;
                this.replaceWantedParameters(urlOut);
                this.getOrigin(urlOut);
                urlOut.errorText = null;
            } catch ( e ) {
                // eslint-disable-next-line
                ;
            }
        },
        roundTripOrigin(urlOut, property) {
            let value = urlOut.origin[property];
            let el = document.getElementById(property + "-" + urlOut.key);
            if ( property === "protocol" ) {
                value = value.trim();
                urlOut.origin["protocol"] = value;
                // special handling as URL object doesn't like you getting this wrong
                if ( !value.match(protocolRegex) ) {
                    el.classList.add("entryError");
                    return;
                }
            }
            urlOut.urlObject[property] = value;
            let decoded = decodeURIComponent(urlOut.urlObject[property]);
            if ( property !== 'hash' && value != decoded ) {
                el.classList.add("entryError");
            } else
                el.classList.remove("entryError");
            this.updateUrlOut(urlOut);

        },
        getOrigin(urlOut) {
            for ( let item of this.$options.local.originlList ) {
                if ( urlOut.urlObject[item] ==undefined ) {
                    urlOut.origin[item] = '';
                } else {
                    let decoded = decodeURIComponent(urlOut.urlObject[item]);
                    urlOut.origin[item] = decoded;
                }
            }
            urlOut.originDisabled = !supportedProtocols.includes(urlOut.urlObject.protocol);
        },
        showExtraChanged() {
            console.log(this.outputType);
            if ( this.outputType == 2 )
                this.buildCSV();
        },
        setAllOriginParamsNamed(urlOut, property) {
            let value = urlOut.origin[property];
            this.urls.forEach((urlOut) => {
                if (urlOut.originDisabled)
                    return;
                urlOut.urlObject[property] = value;
                urlOut.origin[property] = value;
                let el = document.getElementById(property + "-" + urlOut.key);
                el.classList.remove("entryError");
                this.updateUrlOut(urlOut)
            });
        },
        copyTable() {
            let el = document.getElementById("urlTable");
            navigator.clipboard.writeText(el.outerHTML);
        },
        copyCSV() {
            navigator.clipboard.writeText(this.csvText);
        }
    },
    mounted() {
        window.addEventListener('resize', this.resizeWindow);
    },
    created() {
        this.siteURL = new URL(document.URL);
        let optionsText = this.siteURL.searchParams.get("options");
        this.siteURL.search = '';
        if ( optionsText != undefined && optionsText.length > 5 ) {
            let options = JSON.parse(optionsText);
            for ( const i in optionsItems ) {
                if ( options[optionsItems[i]] != undefined )
                    this[optionsItems[i]] = options[optionsItems[i]];
            }
            if ( options['wantedParameters'] instanceof Array )
                this['wantedParameters'] = options['wantedParameters'];
            if ( typeof options['urls'] == "string" )
                this.addURLs(options['urls'], "bottom");
        }
    }
}
</script>

<style>
html {
  font-size: 90%;
}
.form-control, .input-group-text{
  line-height: 1;
  padding: 0.3rem 0.3rem;
  border-radius: 0.2rem;
}
input[readonly],textarea[readonly]{
  background-color:white !important;
}
.outUrl {
  border: 1px solid var(--bs-gray-600);
  background-color: #dbfcfc;
  border-radius: 0.375rem;
}
.showExtra {
  border: 1px solid var(--bs-gray-500);
  background-color: #c7dddd;
  border-radius: 0.375rem;
}
.mw {
  min-width: 5rem;
  text-align: right;
}
.btn.bgg:disabled {
  /*border-color: #9ba9b6 !important;*/
  opacity: 1;
}
.bgg, .bgg:disabled, .bgg:focus {
  border-color: #9ba9b6 !important;
  background-color: var(--bs-gray-200);
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 1.5rem;
  color: #6c757d;
}
.bgg:disabled {
  color: var(--bs-gray-500);
}
.container {
  max-width: 10000px;
}
h1,h4 {
  font-weight: 900;
}
label {
  font-weight: bold;
}
textarea.form-control.TAautosize,pre {
  resize: none;
  overflow: hidden;
  vertical-align:middle;
  padding: 0;
  min-height:1rem;
  word-break: break-all;
  line-height: 1.3rem;
  border: 0;
}
.noBorder {
  border: 0;
}
textarea.form-control.outputAutosize {
  resize: none;
  overflow-x: auto;
  overflow-y: hidden;
  vertical-align:middle;
  padding: 0.4rem;
  min-height:1rem;
  word-break: break-all;
  line-height: 1.5rem;
  white-space: pre;
  overflow-wrap: normal;
}
#urlsText::placeholder {
  text-align: center;
  font-weight: bold;
  font-size: 150%;
  padding-top: 2rem;
}
textarea.form-control.TAautosize:focus, textarea.form-control.outputAutosize:focus   {
  box-shadow: none;
}
.TAAutosizeParent {
  padding: 0.3rem;
  background-color:white;
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}
.btn.noShadow:focus {
  outline: none;
  box-shadow: none;
}
.icon-flipped {
  transform: scaleX(-1);
}
th,td {
  word-break: break-all;
}
.table-wrapper{
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  background-color:white;
}
.urlTableEllipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 30rem;
}
.input-group-text,.form-control {
  border: 1px solid #9ba9b6;
}
.prettyJSON {
  font-size: 80%;
}
.origin-piece {
  width: 20rem;
}
.entryError,.entryError:focus {
  background: #ff3434;
  color: white;
}
#help {
    border: 1px solid var(--bs-gray-600);
    background-color: #dbeafc;
    border-radius: 0.375rem;
    position: absolute;
    z-index:100;
    box-shadow: 0 0 5px 5px var(--bs-gray-600);
    right: 0; left: 0;
}
.help_blink {
    animation: blinker 1s linear 5;
}
@keyframes blinker {
    50% {outline: 0.5rem solid #32a1ce;}
}
</style>